import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-comment\"><path d=\"M711.1 292.5V164.3H89v494.2h128v128.3l397.6-0.5 73.5 73.4 73.5-73 173.4 0.1V292.5H711.1zM135 612.5V210.3h530.1v82.2H217v320h-82z m754 128.3l-146.3-0.1-54.5 54.1-54.6-54.5-370.6 0.5V338.5h626v402.3z\" p-id=\"17737\" /><path d=\"M336.1 516.6h96v46h-96zM528 516.6h96v46h-96zM722.7 516.6h96v46h-96z\" p-id=\"17738\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/comment.svg
// module id = SdtW
// module chunks = 65